import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Injectable} from "@angular/core";
import { ProductService } from "../../product/product-service/product.service";

@Injectable({ providedIn: 'root' })
export class StockDetailResolver implements Resolve<any> {

  constructor(private productService: ProductService) {}

  resolve(route: ActivatedRouteSnapshot) {
    const id = route.paramMap.get('inventoryStockId');
    return this.productService.getProductById(Number(id!));
  }
}
